import { render } from "./WelcomePage.vue?vue&type=template&id=748e1bce&scoped=true"
import script from "./WelcomePage.vue?vue&type=script&lang=js"
export * from "./WelcomePage.vue?vue&type=script&lang=js"

import "./WelcomePage.vue?vue&type=style&index=0&id=748e1bce&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-748e1bce"

export default script